// @ts-nocheck
import { apiWithGetHeader } from '@/service/api';
import { API_USER_SESSION_REFRESH } from '@/service/url';
import { BACKEND_API_BASE_URL } from '@/utilities/constant';
import { getUserAccessToken, restoreActiveProfileFromSession } from '@/utilities/setting';
import { resetAssetsVisibilityEligibility } from '@/hooks/useAssetsVisibilityEligibility';

function writeWhereItLives(key: string, value: string): void {
  try {
    if (sessionStorage.getItem(key) !== null) sessionStorage.setItem(key, value);
    else localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode) — degrade to the stale session */
  }
}

function syncAuthStrategyUser(fresh: any): void {
  try {
    if (sessionStorage.getItem('obd3:auth:user') === null) return;
    sessionStorage.setItem(
      'obd3:auth:user',
      JSON.stringify({
        userId: String(fresh.id),
        role: fresh.role,
        name: fresh.name ?? undefined,
        username: fresh.username ?? undefined,
      }),
    );
    if (fresh.token) sessionStorage.setItem('obd3:auth:token', fresh.token);
  } catch {
    /* noop */
  }
}

let inFlight: Promise<boolean> | null = null;

export function refreshSession(): Promise<boolean> {
  if (inFlight) return inFlight;

  const token = getUserAccessToken();
  if (!token) return Promise.resolve(false);

  inFlight = apiWithGetHeader(BACKEND_API_BASE_URL, undefined, token)
    .get(API_USER_SESSION_REFRESH, { timeout: 20000 })
    .then((response: any) => {
      const fresh = response?.data?.data;
      // Refuse to overwrite a working session with a half-formed payload.
      if (!fresh?.id || !fresh?.role || !fresh?.token) return false;

      writeWhereItLives('user', JSON.stringify(fresh));
      writeWhereItLives('access_token', fresh.token);

      // agentData.agentTelephony comes back at its DB state; re-apply the
      // profile this tab actually logged in as, exactly as a normal reload does.
      restoreActiveProfileFromSession();

      syncAuthStrategyUser(fresh);
      resetAssetsVisibilityEligibility();

      try {
        window.dispatchEvent(new Event('acl-refreshed'));
      } catch {
        /* noop */
      }
      return true;
    })
    .catch(() => false)
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

export function syncAuthCookie(): Promise<boolean> {
  const token = getUserAccessToken();
  if (!token) return Promise.resolve(false);

  return apiWithGetHeader(BACKEND_API_BASE_URL, undefined, token)
    .get(API_USER_SESSION_REFRESH, { timeout: 20000 })
    .then(() => true)
    .catch(() => false);
}

/** Test/logout seam — drop any in-flight refresh so the next call starts clean. */
export function resetSessionRefresh(): void {
  inFlight = null;
}
